import React from 'react';
import './Card.css';

export const Card = ({ className = '', children, ...rest }) => (
  <div className={`ui-card ${className}`.trim()} {...rest}>
    {children}
  </div>
);

export default Card;
